import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#023243',
                secondary: '#00c2a8',
                accent: '#06D676',
                background: '#F0F2F4'
            },
        },
        options: {
            customProperties: true,
        },
    },
})
